import React from 'react';
import PropTypes from 'prop-types';
import IntegrationsModal from './integration_modal';

import contactIcon from '../images/contact_integration.svg';
export default class CancelCalendarModal extends React.Component {

  static propTypes = {
    shown: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  };

  handleSave = () => {
    const { onSave } = this.props;
    onSave("contacts");
  }

  render() {
    const { shown, onCancel } = this.props;

    return (
      <IntegrationsModal
        disconnectModal
        shown={shown}
        title="Disconnect your Contact Sync"
        onCancel={onCancel}
        onSave={this.handleSave}
      >
        <div className="text-center">
          <div className="mb-3">
            <img className="img-thumbnail modal-img" src={contactIcon}/>
          </div>
          <span className="text-muted">
            Your contacts will no longer sync with your Google, Office, ICloud or Yahoo account
          </span>
        </div>
      </IntegrationsModal>
    );
  }
}
